export default __webpack_public_path__ + "static/media/picture-icon-disable.744fbb8a.svg";